import React from "react";
import { withRouter } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import Quill from "quill";
import ImageResize from "quill-image-resize-module-react";
import { Button, Col, Input, message, Modal, Row, Select } from "antd";
import { axiosInstance } from "../../../commons/commons";
import { building } from "../../../constants/url";

Quill.register("modules/imageResize", ImageResize);
class EmailTemplate extends React.Component {
  _isMounted = false;
  state = {
    mailModalIsVisible: false,
    mailTo: [],
    mailCc: [],
    mailBCc: [],
    mailSubject: "",
    mailBody: "",
    buildingData: {
      list: [],
    },
  };

  getInitialState = async () => {
    let state = {
      mailModalIsVisible: false,
      mailTo: [],
      mailCc: [],
      mailBCc: [],
      mailSubject: "",
      mailBody: "",
      buildingData: {
        list: [],
      },
    };
    await axiosInstance
      .get(building)
      .then((res) => {
        if (res.data.success) {
          state.buildingData = {
            list: res.data.message,
          };
        }
      })
      .catch(() => {});
    return state;
  };

  sendMail = () => {
    if (!(this.state.mailTo || []).length) {
      return message.error("Please enter at least one receipient !");
    }
    if (!this.state.mailSubject) {
      return message.error("Please enter subject !");
    }
    if (!this.state.mailBody) {
      return message.error("Please enter mail body !");
    }
  };

  componentDidMount() {
    this._isMounted = true;
    this.getInitialState().then((st) => {
      if (this._isMounted) this.setState(st);
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Modal
          visible={this.state.mailModalIsVisible}
          okText="Send"
          onCancel={() => {
            this.setState({ mailModalIsVisible: false });
          }}
          title={
            `Compose` +
            (this.state.mailSubject ? ` - ${this.state.mailSubject}` : "")
          }
          onOk={() => {
            this.sendMail();
          }}
        >
          <Row>
            <Col span={24}>
              <Select
                mode="tags"
                tokenSeparators={[","]}
                placeholder="To"
                style={{ width: "100%", marginBottom: 10 }}
                filterOption={(input, option) => {
                  if (option.children)
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                }}
                onChange={(values) => {
                  this.setState({ mailTo: values });
                }}
                value={this.state.mailTo}
              >
                <Select.Option key="all_tenants" value={"all_tenants"}>
                  All Tenants
                </Select.Option>
                {this.state.buildingData.list.map((building, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={`building__${building.BuildingID}`}
                    >
                      {building.BuildingName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Select
                mode="tags"
                tokenSeparators={[","]}
                placeholder="Cc"
                style={{ width: "100%", marginBottom: 10 }}
                filterOption={(input, option) => {
                  if (option.children)
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                }}
                onChange={(values) => {
                  this.setState({ mailCc: values });
                }}
                value={this.state.mailCc}
              >
                <Select.Option key="all_tenants" value={"all_tenants"}>
                  All Tenants
                </Select.Option>
                {this.state.buildingData.list.map((building, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={`building__${building.BuildingID}`}
                    >
                      {building.BuildingName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Select
                mode="tags"
                tokenSeparators={[","]}
                placeholder="BCc"
                style={{ width: "100%", marginBottom: 10 }}
                filterOption={(input, option) => {
                  if (option.children)
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                }}
                onChange={(values) => {
                  this.setState({ mailBCc: values });
                }}
                value={this.state.mailBCc}
              >
                <Select.Option key="all_tenants" value={"all_tenants"}>
                  All Tenants
                </Select.Option>
                {this.state.buildingData.list.map((building, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={`building__${building.BuildingID}`}
                    >
                      {building.BuildingName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Input
                placeholder="Subject"
                style={{ width: "100%", marginBottom: 10 }}
                value={this.state.mailSubject}
                onChange={(e) => {
                  this.setState({ mailSubject: e.target.value });
                }}
              />
            </Col>
          </Row>
          <ReactQuill
            // style={{ minHeight: window.innerHeight }}
            theme="snow"
            ref={(ref) => {
              this.quillRef = ref;
            }}
            modules={{
              imageResize: {
                modules: ["Resize", "DisplaySize", "Toolbar"],
              },
              toolbar: [
                [{ size: ["small", false, "large", "huge"] }], // Font size dropdown
                [
                  "bold",
                  "italic",
                  "underline",
                  // "strike"
                ],
                [{ color: [] }, { background: [] }],
                [{ align: [] }],
                [{ script: "sub" }, { script: "super" }], // superscript/subscript
                [
                  { list: "ordered" },
                  { list: "bullet" },
                  { indent: "-1" },
                  { indent: "+1" },
                ],
                [{ direction: "rtl" }], // text direction
                ["link", "image"],
                ["clean"],
              ],
            }}
            value={this.state.mailBody}
            onChange={(e) => this.setState({ mailBody: e })}
          />
        </Modal>
        <Button
          onClick={() => {
            this.setState({ mailModalIsVisible: true });
          }}
        >
          Compose
        </Button>
        <Button
          onClick={() => {
            if (this.quillRef)
              navigator.clipboard.writeText(
                this.quillRef.editor.root.innerHTML
              );
          }}
        >
          copy
        </Button>
      </div>
    );
  }
}

export default withRouter(EmailTemplate);
